import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    font-family: 'Arial', sans-serif;
    margin: 0;
    transition: all 0.3s linear;
  }

  h1, h2, h3, h4, h5, h6 {
    color: ${({ theme }) => theme.heading};
  }

  .card {
    background-color: ${({ theme }) => theme.cardBg};
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  }
  .skeleton-image,
  .skeleton-title,
  .skeleton-subtitle {
    background: ${({ theme }) => theme.skeletonCard};
    background-size: 200% 100%; 
    animation: shimmer 2s infinite linear; 
  }
`;
